import React, { useState, useEffect } from 'react';
import SubscriptionsTile from './components/SubscriptionsTile/SubscriptionsTile';
import { SubscriptionProvider } from './context/subscriptionContext';
import './App.css';

function App(props) {
  const { organization } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    localStorage.setItem('Organization', organization);
  }, []);

  return (
    <div className="App">
      <SubscriptionProvider>
        <SubscriptionsTile />
      </SubscriptionProvider>
    </div>
  );
}

export default App;
